import AppLayout from '@/layout/AppLayout.vue'
const Financial = () => import('@/view/financial/Financial.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/financial',
        component: Financial,
        meta: { key: 'financial' },
        props: route => ({ ...route.query }),
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
